import { jsx as _jsx } from "react/jsx-runtime";
import { Clock } from "@air/next-icons";
import { MONTH_DAY_YEAR_FORMAT, parseAirDateToISO } from "@air/utilities";
import { format } from "__barrel_optimize__?names=format!=!date-fns";
import { memo } from "react";
import { useSelector } from "react-redux";
import { InfoPanelDetailsSection } from "~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailsSection";
import { InfoPanelDetailValue } from "~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailValue";
import { centralizedClipUpdatedAtSelector } from "~/store/centralizedClip/selectors";
export const InfoPanelDateModified = /*#__PURE__*/ memo(()=>{
    const updatedAt = useSelector(centralizedClipUpdatedAtSelector);
    const formattedUpdatedAt = format(parseAirDateToISO(updatedAt), MONTH_DAY_YEAR_FORMAT);
    return /*#__PURE__*/ _jsx(InfoPanelDetailsSection, {
        Icon: Clock,
        title: "Last Modified",
        children: /*#__PURE__*/ _jsx(InfoPanelDetailValue, {
            value: formattedUpdatedAt,
            additionalInfo: "Last modified"
        })
    });
});
InfoPanelDateModified.displayName = "InfoPanelDateModified";
